import SearchFilter from './SearchFilterContainer';

export default SearchFilter;
